import React from 'react';
import {
  Container,
  Tab,
  Tabs,
  colors
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import EkGaranti from './EkGaranti';
import TamamlayiciÜrün from './Tamamlayici';




const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  tabs: {
    marginTop: theme.spacing(1)
  },
  container: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  }
}));

function Performance({ match, history }) {
  const classes = useStyles();
  const [readonly] = useState(true);
  const { tab: currentTab } = match.params;
  const Alltabs = [
    {
      value: 'EkGaranti',
      index: 0,
      label: 'Ek-Garantİ',
      visible: true,
      component: <EkGaranti  readonly={readonly} />
    },
    {
      value: 'Tamamlayici',
      index: 1,
      label: 'Tamamlayıcı Ürün',
      visible: true,
      component: <TamamlayiciÜrün  readonly={readonly} />
    },
  ]
  const tabs = Alltabs.filter(t => t.visible).map((t, i) => {
    return { ...t, index: i };
  });

  let currentTabIndex = 0;

  if (currentTab !== undefined) {
    currentTabIndex = tabs.filter(d => d.value === currentTab)[0]?.index;
  }
  const [index, setindex] = useState(currentTabIndex);
  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      if (mounted) {
        setindex(currentTabIndex);
      }
    };
    fetchTodos();

    return () => {
      mounted = false;
    };
  }, [currentTabIndex]);



  const handleChangeIndex = index => {
    let indexValueId = tabs.filter(d => d.index === index)[0]?.value;
    history.push(indexValueId);
  };
  const handleChange = (event, value) => {
    let indexValue = tabs.filter(d => d.index === value)[0]?.value;
    history.push(indexValue);
  };


  return (
    <Page
      className={classes.root}
      title="Kullanıcı"
    >
      <Container maxWidth="lg">
        <Header />
        <Tabs
            value={index}
            className={classes.tabs}
            textColor="secondary"
            scrollButtons="on"
            indicatorColor="primary"
            variant="scrollable"
            onChange={handleChange}
          >
            {tabs.map(t => {
              return (
                t.visible && (
                  <Tab key={t.index} label={t.label} value={t.index} />
                )
              );
            })}
          </Tabs>
          <SwipeableViews index={index} onChangeIndex={handleChangeIndex}>
            {tabs.map(t => {
              return t.visible && currentTab === t.value ? (
                <div key={t.index}>
                  {t.component}
                 
                </div>
              ) : (
                <div key={t.index}></div>
              );
            })}
          </SwipeableViews>
      </Container>
    </Page>
  );
}



export default Performance;
